<div class="row banner task-amend">
  <div class="col">
    <h6 class="pt-5px">
      <strong>Configure Document Mapping</strong>
    </h6>
  </div>
  <div class="col">
    <button (click)="createActivity()" class="btn btn-secondary float-end">
      Create New Document Mapping
    </button>
  </div>
</div>

<form [formGroup]="activityFilter" class="search">
  <div class="d-flex justify-content-start">
    <div class="m-0 me-3 w-35">
      <ng-select
        [items]="countries"
        [closeOnSelect]="true"
        [multiple]="false"
        bindLabel="displayText"
        bindValue="id"
        formControlName="country"
        [placeholder]="'Country'"
        (change)="onCountryChange($event)">
      </ng-select>
    </div>

    <div class="m-0 me-3 w-35">
      <ng-select
        [items]="officeLocationsInfo"
        [closeOnSelect]="true"
        [multiple]="false"
        bindLabel="displayText"
        bindValue="id"
        formControlName="officeLocation"
        [placeholder]="'Office location'">
      </ng-select>
    </div>

    <div class="m-0 me-3 w-35">
      <ng-select
        [items]="officeLegalEntitiesInfo"
        [closeOnSelect]="true"
        [multiple]="false"
        bindLabel="displayText"
        bindValue="id"
        formControlName="officeLegalEntity"
        [placeholder]="'Office legal entity'">
      </ng-select>
    </div>

    <div class="m-0 me-3 w-35 d-flex flex-row">
      <button
        (click)="clearForm()"
        style="height: 29px"
        eosDebounce
        class="btn btn-primary ms-2">
        Clear
      </button>

      <button
        (click)="onSubmit()"
        style="height: 29px"
        eosDebounce
        [disabled]="!activityFilter.valid"
        class="btn btn-primary ms-2"
        type="submit">
        Search
      </button>
    </div>
  </div>
</form>

<div class="d-flex table-resp candid-table mt-3" *ngIf="activities.length">
  <table class="table table-bordered table-hover">
    <thead>
      <tr>
        <th [hidden]="true" scope="col">#</th>
        <th scope="col">Document Type</th>
        <th scope="col">Office Legal Entity</th>
        <th scope="col">Office Location</th>
        <th scope="col">Country</th>
        <th scope="col">Active/Inactive</th>
        <th scope="col" class="text-center">Action</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let act of activities; index as i">
        <td [hidden]="true">{{ i + 1 }}</td>
        <td>{{ act.documentType?.documentTypeName }}</td>
        <td>{{ act.legalEntity?.displayText }}</td>
        <td>{{ act.location?.displayText }}</td>
        <td>{{ act.country?.displayText }}</td>
        <td>{{ act.isActive ? 'Active' : 'Inactive' }}</td>
        <td class="text-center">
          <img
            class="cursor-pointer"
            title="Edit configuration"
            (click)="editActivity(act.id)"
            src="design/images/edit.png"
          />
        </td>
      </tr>
    </tbody>
  </table>
</div>

<div class="card mt-3 text-center d-flex p-5" *ngIf="!activities.length">
  <div class="card-body">No documents found for the given filter values</div>
</div>